<div class="modal-header" *ngIf="isModal">
  <h5 class="modal-title">{{'container.editTitle' | translate}}</h5>
  <div>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <button type="save" class="close" (click)="save()" aria-label="Close">
      <span aria-hidden="true"><i class="fas fa-save"></i></span>
    </button>
  </div>
</div>
<div [ngClass]="{'modal-body': isModal, 'card': !isModal}">
  <div [ngClass]="{'card-body': !isModal}">
    <div class="row" >
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'container.targa' | translate}}</label>
        <input type="text" #targa="ngModel" required [placeholder]="'container.targa' | translate" [(ngModel)]="item.targa" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!targa.valid && (targa.dirty || targa.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'container.partenza' | translate}}</label>
        <input type="date" #partenza="ngModel" required [placeholder]="'container.partenza' | translate" [(ngModel)]="item.partenza" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!partenza.valid && (partenza.dirty || partenza.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'container.datascarico' | translate}}</label>
        <input type="date" #data="ngModel"  [placeholder]="'container.datascarico' | translate" [(ngModel)]="item.arrivo" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!data.valid && (data.dirty || data.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'container.arrivo' | translate}}</label>
        <input type="datetime-local" #arrivo="ngModel"  [placeholder]="'container.arrivo' | translate" [(ngModel)]="item.data" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!arrivo.valid && (arrivo.dirty || arrivo.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'container.magazzino' | translate}}</label>
        <input type="text" #magazzino="ngModel"  [placeholder]="'container.magazzino' | translate" [(ngModel)]="item.magazzino" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!magazzino.valid && (magazzino.dirty || magazzino.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'container.Ordine' | translate}}</label>
        <input type="text" [placeholder]="'container.Ordine' | translate" [(ngModel)]="item.ordine" name="nome" class="form-control">
      </div>
      <div class="col-lg-12 form-group">
        <label class="mb-0 text-dark">{{'Note' | translate}}</label>
        <textarea type="text" [placeholder]="'Note' | translate" [(ngModel)]="item.note" name="nome" class="form-control"></textarea>
      </div>
      <div class="col-lg-12 form-group">
        <label class="mb-0 text-dark">{{'Ricambi' | translate}}</label>
        <textarea type="text" [placeholder]="'Ricambi' | translate" [(ngModel)]="item.ricambi" name="nome" class="form-control"></textarea>
      </div>
    </div>
  </div>
</div>
<div class="card">
  <div class="card-body">
    <div class="form-group">
      <label for="fornitore" class="control-label col-form-label">{{'container.spedizione' | translate}}</label>
      <ng-multiselect-dropdown [settings]="DropdownSettings" [placeholder]="'container.spedizione' | translate" id="fornitore"
                               [data]="Spedizioni" [(ngModel)]="spedizioniSelezionate">
      </ng-multiselect-dropdown>
    </div>
    <div class="d-flex justify-content-start align-items-center">
      <div class="form-group">
        <label class="mb-0 text-dark">{{'container.Fattura' | translate}}</label>
        <input type="text" #magazzino="ngModel" required [placeholder]="'container.Fattura' | translate" [(ngModel)]="Fattura" name="nome" class="form-control">
      </div>
      <div class="form-group">
        <label class="mb-0 text-dark">Data {{'container.Fattura' | translate}}</label>
        <input type="date" #magazzino="ngModel" required [placeholder]="'container.Fattura' | translate" [(ngModel)]="dataFattura" name="nome" class="form-control">
      </div>

      <button (click)="setFattura()" class=" btn btn-outline-primary p-2 waves-effect waves-light">
        <span class="ml-1 "> Assegna </span>
      </button>

    </div>
    <div class="d-flex justify-content-start align-items-center">
      <div class="form-group">
        <label class="mb-0 text-dark">{{'Proforma' | translate}}</label>
        <input type="text" #magazzino="ngModel" required [placeholder]="'Proforma' | translate" [(ngModel)]="Proforma" name="nome" class="form-control">
      </div>
      <div class="form-group">
        <label class="mb-0 text-dark">Data {{'Proforma' | translate}}</label>
        <input type="date" #magazzino="ngModel" required [placeholder]="'Proforma' | translate" [(ngModel)]="dataProforma" name="nome" class="form-control">
      </div>

      <button (click)="setProforma()" class=" btn btn-outline-primary p-2 waves-effect waves-light">
        <span class="ml-1 "> Assegna </span>
      </button>

    </div>
    <app-voci-di-costo
      *ngIf="item && item.voci"
      [isModifyDisabled]="false"
      [HasIva]="false"
      [HasTotale]="false"
      [HasPrezzo]="false"
      [HasProdottiDropdown]="false"
      [externalAddFunction]="true"
      [externalEditFunction]="true"
      [externalDeleteFunction]="true"
      [prezzoEditabile]="false"
      [voceEditabile]="false"
      (AddClicked)="EditVoce()"
      (UpdateClicked)="EditVoce($event)"
      (DeleteClicked)="DeleteVoce($event)"
      [CampiAggiuntivi]="[{nome: 'Ordine di Spedizione', oggetti: ['ordine']}, {nome: 'Fattura', oggetti: ['fattura'], modificabile: true}, {nome: 'Data Fattura', oggetti: ['dataFattura'], inputType: 'date', modificabile: true}, {nome: 'Fattura', oggetti: ['proforma'], modificabile: true}, {nome: 'Data Fattura', oggetti: ['dataProforma'], inputType: 'date', modificabile: true}]"
      [HasUm]="false"
      [myProp]="item"
      (resetpage)="refresh()
"></app-voci-di-costo>
    <app-file-uploader *ngIf="item?.id" [url]="'/primanota/container/file'" [(listafile)]="item.files" [(id)]="item.id" (onChange)="refresh()" ></app-file-uploader>
  </div>
</div>
<div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
  <button (click)="save()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> <i class="fas fa-save"></i> {{'container.salva' | translate}} </span>
  </button>
  <button (click)="InviaAdhoc()" [disabled]="item?.invio" [ngbTooltip]="item?.invio ? 'Già inviato' : 'Invia'" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> <i class="fas fa-save"></i> {{'Invia ad adhoc ' | translate}} </span>
  </button>
</div>
